export function safeUrl(url) {
  try {
    const parsed = new URL(url)
    return (parsed.protocol === "http:" || parsed.protocol === "https:") ? url : null
  } catch {
    return null
  }
}
